import React, {useEffect, useMemo, useRef, useState} from "react";
import {IonItem, IonItemGroup, IonModal} from "@ionic/react";
import {UserState, userStore} from "../../api/AuthService";
import { DriverProfile } from "../../api/model/DriverProfile";

const InboxMessageBox = (props: any) => {

    const [modalOpen, setModalOpen] = useState(true);
    const {userInfo}: { userInfo: DriverProfile } = userStore((state: UserState) => ({userInfo: state.driver}));
    const messagesEndRef = useRef<any>(null);
    const [messageEnd, setMessageEnd] = useState<any>()

    const scrollHere = useMemo(() => {
      const maps = props.msgArray.map(function(element: any, index: number){
        console.log("element", props.msgArray);
        let direction = ""
        let color = ""
        if (element.isFromDriver !== undefined) {
          direction = element.isFromDriver ? "right" : "left"
          color = element.isFromDriver ? "primary" : "secondary"
        } else {
          direction = element.from === userInfo.driverCode ? "right" : "left"
          color = element.from === userInfo.driverCode ? "primary" : "secondary"
        }
          
          return  <div id={`${index}`} style={direction === "right" ? {justifyContent: "end", display: "grid"} : {justifyContent: "start", display: "grid", marginBottom: "10px"}}>
                  <div className='item-container' style={ color === "primary" ? { backgroundColor: "#99cc00", borderRadius: "20px", maxWidth: "70vw", padding: "5px 10px", textAlign: "center", color: "#000"}: { backgroundColor: "#fff", borderRadius: "20px", maxWidth: "70vw", padding: "5px 10px", textAlign: "center", color: "#000"}}>
                    <span style={{fontSize: "16px", fontWeight: '500'}}>{element.message !== undefined ? element.message : element.body}</span>
                  </div>
                  <div style={direction === "right" ? {justifyContent: "end", display: "grid"} : {justifyContent: "start", display: "grid"}}>
                    <span style={{opacity: '40%', fontSize: "12px", fontWeight: "600", color: '#000'}}>{element.time}</span>
                  </div>
                </div>
      })

      console.log("maps length", maps.length - 1);
      setMessageEnd(maps.length - 1)
      return maps
    }, [props])
            
    useEffect(() => {
      setTimeout(() => {
          console.log("element", messageEnd);
          let element: any = document.getElementById("messagesEndRef");
          element?.scrollIntoView();
          console.log("msgArray", props)

      }, 250)
    }, []);

    return <div>
        {scrollHere}
      <div id="messagesEndRef" style={{height: "10px"}}></div>
    </div>
}
export default InboxMessageBox;
